import { render, staticRenderFns } from "./Bonusreceive.vue?vue&type=template&id=619929b9&scoped=true&"
import script from "./Bonusreceive.vue?vue&type=script&lang=js&"
export * from "./Bonusreceive.vue?vue&type=script&lang=js&"
import style0 from "./Bonusreceive.vue?vue&type=style&index=0&id=619929b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619929b9",
  null
  
)

export default component.exports